<template>
  <div>
    <hr>
    <b-row>
      <b-col sm="6" lg="8" class="row-align-left">
        <label>I give my consent for the Diabetes Coalition of Palm Beach County to perform a Diabetes Risk Assessment which includes diabetes risk factor questions, health biomarker tests, which may include: a BMI score, rapid result A1c, glucose, and lipid panel tests via a finger stick, and blood pressure screening.  Upon completion of the screening, a Diabetes Risk Assessment Result Card with your scores will be provided.</label>
      </b-col>
      <b-col sm="6" lg="4">
        <b-row>
          <b-col md="6" >
            <label class="float-left" for>
              <input
                type="radio"
                v-model="$v.participantConsent.$model"
                class="option-input radio"
                :class="{ 'invalid-radio-button': participantConsentState }"
                name="rd1"
                :value="true"
              >
              Yes
            </label>
          </b-col>
          <b-col md="6" >
            <label class="float-left" for>
              <input
                type="radio"
                v-model="$v.participantConsent.$model"
                class="option-input radio"
                :class="{ 'invalid-radio-button': participantConsentState }"
                name="rd1"
                :value="false"
              >
              No
            </label>
          </b-col>
        </b-row>
      </b-col>
    </b-row>
    <hr>
    <b-row>
      <b-col sm="6" lg="8" class="row-align-left">
        <label>I further acknowledge that the Diabetes Coalition has put in place preventative measures as recommended by the Center for Disease Control (CDC) and Prevention to reduce the spread of the Coronavirus/COVID-19, however, cannot fully guarantee that I will not become infected.  I accept that I still may be increasing my risk to exposure to COVID 19 by attending this event, and release the Diabetes Coalition of Palm Beach County, Inc. from any and all liability and agree to hold them harmless in this regard.</label>
      </b-col>
      <b-col sm="6" lg="4">
        <b-row>
          <b-col md="6" >
            <label class="float-left" for>
              <input
                type="radio"
                v-model="$v.participantAcknowledgement.$model"
                class="option-input radio"
                :class="{ 'invalid-radio-button': participantAcknowledgementState }"
                name="rd2"
                :value="true"
              >
              Yes
            </label>
          </b-col>
          <b-col md="6" >
            <label class="float-left" for>
              <input
                type="radio"
                v-model="$v.participantAcknowledgement.$model"
                class="option-input radio"
                :class="{ 'invalid-radio-button': participantAcknowledgementState }"
                name="rd2"
                :value="false"
              >
              No
            </label>
          </b-col>
        </b-row>
      </b-col>
    </b-row>
    <hr>
    <nav class="navbar fixed-bottom survey-nav-buttons">

        <b-row class="pt-3 w-100">
          <b-col sm="2">
            <b-btn
              variant="outline-primary"
              size="lg"
              class="w-120"
              @click="cancelSurvey"
              >Cancel</b-btn
            >
          </b-col>
          <b-col sm="8">
            <div v-if="ShowErrorMsg">             
              <font-awesome-icon icon="exclamation-triangle" class="fa-2x"/>   
              <span class="error-message">All fields are required!</span>
              </div>
          </b-col>
          <b-col sm="2">
            <b-btn
              variant="primary"
              size="lg"
              class="w-120"
              @click="moveNext"
              >Next</b-btn
            >
          </b-col>
        </b-row>
      </nav>
      <b-modal ref="proceed-modal">
        <div class="d-block text-center">
          <h5>We cannot continue since you have answered NO</h5>
        </div>
        <template #modal-footer>
          <b-button size="sm" variant="success" @click="cancelSurvey()">
            Yes - Cancel
          </b-button>
          <b-button size="sm" variant="danger" @click="hide()">
            No
          </b-button>
        </template>
      </b-modal>
  </div>
</template>
<script>
import { required, maxLength } from "vuelidate/lib/validators";
import surveyNav from "@/components/SurveyNav";

export default {
  name: "confirmation-pin",
  props: ["surveyData", "isValid"],
  data: () => ({
    selected: null,
    participantConsent: null,
    participantAcknowledgement: null,
    ShowErrorMsg: false,
  }),
  validations: {
    participantAcknowledgement: {
      required
    },
    participantConsent: {
      required
    }
  },
  components: {
    surveyNav
  },
  methods: {
    moveNext() {
      if (!this.$v.$invalid) {
        if (this.participantAcknowledgement && this.participantConsent){
          this.$emit("move-next", {
            participantConsent: this.participantConsent,
            participantAcknowledgement: this.participantAcknowledgement,
            isValid: true
          });
          this.referenceCode = null; //reset the value to null for the next survey
        } else {
          this.$refs['proceed-modal'].show();
        }        
      } else {
        this.showErrorMsg = true;
        this.$v.$touch();
      }
    },
    cancelSurvey() {
      this.$refs['proceed-modal'].hide();
      this.$emit('cancel-survey');
    },
    hide() {
      this.$refs['proceed-modal'].hide();
    },
    onCreated() {
      console.log("Im here")
      this.participantAcknowledgement = this.surveyData.ParticipantAcknowledgement;
      this.participantConsent = this.surveyData.ParticipantConsent;
    }
  },
  computed: {
    //Radio buttons must return a !result
    participantConsentState () {
      return this.$v.participantConsent.$dirty ? !this.$v.participantConsent.required : null;  
    },
    participantAcknowledgementState () {
      return this.$v.participantAcknowledgement.$dirty ? !this.$v.participantAcknowledgement.required : null;  
    },
  },
  watch: {
    
    // participantConsent() {
    //   if (this.$v.participantConsent.required)
    //     this.surveyData.participantConsent = this.participantConsent;
    // },
    // participantAcknowledgement() {
    //   if (this.$v.participantAcknowledgement.required) {
    //     this.surveyData.participantAcknowledgement = this.participantAcknowledgement;
    //   }
    // },
  },
  mounted() {
    this.onCreated();
  }
};
</script>

<style scoped>
.navbar{
  background-color: #ffffff;
}
.survey-nav-buttons{
  padding-bottom: 60px;
}
.row{
  padding-bottom: 10px;
}
.fa-exclamation-triangle{
  color: red;
}
.error-message{
  color: red;
  font-size: 1.5em;
  padding-left: 10px;
}
.invalid-radio-button{
  background-color: red;
}
</style>
